import { BUTTON_PRESS } from './baseEvents'

const LABELS_SETTINGS = 'Labels - Settings'
const LABELS_DEVICE_DRAWER = 'Labels - Device Drawer'

export const LABEL_SETTINGS_VIEW = `${BUTTON_PRESS} ${LABELS_SETTINGS} - View`
export const LABEL_SETTINGS_OPEN_CREATE = `${BUTTON_PRESS} ${LABELS_SETTINGS} - Click Add`
export const LABEL_SETTINGS_SHOW_DISABLED = `${BUTTON_PRESS} ${LABELS_SETTINGS} - Show Disabled`
export const LABEL_SETTINGS_CLICK_RENAME = `${BUTTON_PRESS} ${LABELS_SETTINGS} - Click Rename`
export const LABEL_SETTINGS_CLICK_REMOVE = `${BUTTON_PRESS} ${LABELS_SETTINGS} - Click Remove`
export const LABEL_SETTINGS_RENAME_CONFIRM = `${BUTTON_PRESS} ${LABELS_SETTINGS} - Rename Confirm`
export const LABEL_SETTINGS_RENAME_CANCEL = `${BUTTON_PRESS} ${LABELS_SETTINGS} - Rename Cancel`
export const LABEL_SETTINGS_DISABLE_MODAL_SHOWN = `${LABELS_SETTINGS} - Disable Modal Shown`
export const LABEL_SETTINGS_DUPLICATE_WARNING_SHOWN = `${LABELS_SETTINGS} - Duplicate Warning Shown`
export const LABEL_WARNING_TOO_LONG = 'Labels - Warning Too Long'
export const LABEL_WARNING_MAX_LENGTH = 'Labels - Character Limit Hit'

export const LABEL_SETTINGS_CREATE_SUCCESS = `${LABELS_SETTINGS} - Create - Success`
export const LABEL_SETTINGS_CREATE_FAILURE = `${LABELS_SETTINGS} - Create - Failure`
export const LABEL_SETTINGS_RENAME_SUCCESS = `${LABELS_SETTINGS} - Rename - Success`
export const LABEL_SETTINGS_RENAME_FAILURE = `${LABELS_SETTINGS} - Rename - Failure`
export const LABEL_SETTINGS_DISABLE_SUCCESS = `${LABELS_SETTINGS} - Disable - Success`
export const LABEL_SETTINGS_DISABLE_FAILURE = `${LABELS_SETTINGS} - Disable - Failure`

export const LABEL_DEVICE_DRAWER_ADD_SUCCESS = `${LABELS_DEVICE_DRAWER} - Add - Success`
export const LABEL_DEVICE_DRAWER_ADD_FAILURE = `${LABELS_DEVICE_DRAWER} - Add - Failure`
export const LABEL_DEVICE_DRAWER_CREATE_SUCCESS = `${LABELS_DEVICE_DRAWER} - Create - Success`
export const LABEL_DEVICE_DRAWER_CREATE_FAILURE = `${LABELS_DEVICE_DRAWER} - Create - Failure`
export const LABEL_DEVICE_DRAWER_REMOVE_SUCCESS = `${LABELS_DEVICE_DRAWER} - Remove - Success`
export const LABEL_DEVICE_DRAWER_REMOVE_FAILURE = `${LABELS_DEVICE_DRAWER} - Remove - Failure`
export const LABEL_DEVICE_DRAWER_OPEN_PICKER = `${BUTTON_PRESS} ${LABELS_DEVICE_DRAWER} - Click Add`
